import React from 'react'
import {
  Button,
  Modal,
  Form,
  Input,
  Table,
  Checkbox,
  Dropdown,
  Icon,
  Label,
  Message,
  Pagination,
  Grid,
  Tab
} from 'semantic-ui-react'
import _ from 'lodash';
import './ClerksView.scss'

import InputMask from 'react-input-mask';
import {Formik} from 'formik';
import {newClerkSchema, deviceSchema, changePasswordSchema, editClerkSchema} from '../models/formValidation';
import {USER_ROLES} from "../../../constants";

import {getLanguageScope} from '../../../helpers';

const _i18n = getLanguageScope('clerks_management');

export default class ClerksView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedDeviceRow: null,
      selectedUserId: -1,
      searchQuery: ''
    };
  }

  componentDidMount() {
    const {loadClerksDevices} = this.props;
    loadClerksDevices && loadClerksDevices()
  }

  checkAnotherStoreOwnerDevice = (device) => {
    const { owners, current_user_id } = this.props;

    if(device.clerk_id === current_user_id){
      return false;
    }

    if(device.is_own_device){
      return false;
    }

    return _.find(owners, (o) => o.id === device.clerk_id);
  };

  handleSearchChange = (e, { searchQuery }) => this.setState(() => ({searchQuery: searchQuery }));

  renderDevices() {
    const {clerkDevices, clerks, owners, loading, current_user_id} = this.props;
    const {selectedDeviceRow, searchQuery} = this.state;

    const selectOptions = _.map(clerks, (clerk) => ({
      value: clerk.id, text: (clerk.first_name || clerk.last_name) ? `${clerk.first_name} ${clerk.last_name}` : `+${clerk.country_code}${clerk.phone_number}`
    }));

    selectOptions.unshift({value: current_user_id, text: _i18n('assign_on_me'), label: { color: 'green', empty: true, circular: true }});
    selectOptions.unshift({value: -1, text: _i18n('device_without_user'), label: { color: 'grey', empty: true, circular: true }});

    if (!(clerkDevices && clerkDevices.length)) {
      return (
        <Table.Row>
          <Table.Cell colSpan={'6'}>{_i18n('devices_not_found')}</Table.Cell>
        </Table.Row>
      )
    }

    return _.map(clerkDevices, (device, index) => {

      if(this.checkAnotherStoreOwnerDevice(device)){
        return this.renderOwnerDevice(device, index);
      }

      return (
        <Table.Row className={device.is_own_device ? 'background-grey' : ''} key={index}>
          <Table.Cell>
            <Icon style={{cursor: 'pointer', paddingRight: 20}} name='edit'
                  onClick={() => this.handleEditDevice(device.device_id, device.info)}/>
            {device.info}
          </Table.Cell>
          <Table.Cell width="5">
            {device.is_own_device ?
              <span color={'red'}>{_i18n('own_device')}</span> :
              <Dropdown placeholder={_i18n('select_employee')}
                        fluid
                        selection
                        options={selectOptions}
                        onChange={(e, {value}) => this.updateDevice(device.device_id, 'clerk_id', value)}
                        onSearchChange={this.handleSearchChange}
                        search
                        searchQuery={searchQuery}
                        value={device.clerk_id}
              />}

          </Table.Cell>
          <Table.Cell textAlign="center">
            <Checkbox toggle
                      disabled={device.is_own_device || (loading && selectedDeviceRow === device.device_id)}
                      onChange={() => this.updateDevice(device.device_id, 'enabled', !device.enabled)}
                      checked={device.enabled}/>
          </Table.Cell>
        </Table.Row>
      )
    })
  }

  renderOwnerDevice(device, key){
    return (
      <Table.Row className={'background-grey'} key={key}>
        <Table.Cell>
          <Icon disabled={true} style={{cursor: 'pointer', paddingRight: 20}} name='edit' onClick={() => {}}/>
          {device.info}
        </Table.Cell>
        <Table.Cell width="5">
          <span color={'red'}>{_i18n('store_owner_device')}</span>
        </Table.Cell>
        <Table.Cell textAlign="center"/>
      </Table.Row>
    )
  }

  renderEmployees() {
    const {employees} = this.props;

    if (!(employees && employees.length)) {
      return (
        <Table.Row>
          <Table.Cell colSpan={'6'}>{_i18n('employees_not_found')}</Table.Cell>
        </Table.Row>
      )
    }

    return _.map(employees, (clerk, index) => {
      return (
        <Table.Row className={clerk.role === USER_ROLES.STORE_OWNER ? 'background-grey' : ''} key={index}>
          <Table.Cell>
            {`${clerk.first_name} ${clerk.last_name}`}
            {clerk.role === USER_ROLES.STORE_OWNER ? <span className={'own-user-label'}>{_i18n('my_user')}</span> : ''}
          </Table.Cell>
          <Table.Cell>
            {`${clerk.country_code}${clerk.phone_number}`}
          </Table.Cell>
          <Table.Cell>
            {clerk.email}
          </Table.Cell>
          <Table.Cell width="1">
            <Icon className={'icon-center'} name='edit'
                  onClick={() => this.handleClerkModal(clerk.id, 'edit_clerk', true)}/>
          </Table.Cell>
          <Table.Cell width="1">
            <Icon className={'icon-center'} name='key'
                  onClick={() => this.handleClerkModal(clerk.id, 'change_password_clerk', true)}/>
          </Table.Cell>
        </Table.Row>
      )
    })

  }

  updateDevice = (deviceId, field, value) => {
    const {updateDevice} = this.props;

    this.setState({
      selectedDeviceRow: deviceId
    });

    updateDevice(deviceId, field, value)
  };

  handleEditDevice = (deviceId, deviceName) => {
    const {setOpenEditDeviceModal, setEditDeviceInfo} = this.props;

    setEditDeviceInfo({deviceId, deviceName});
    setOpenEditDeviceModal(true)
  };

  handleModal = (modal_name, state) => {
    const {setOpenClerkModal, setOpenDeviceModal, setOpenClerkChangePasswordModal, setOpenClerkEditModal} = this.props;

    if (modal_name === 'create_clerk') {
      return setOpenClerkModal(state);
    }

    if (modal_name === 'create_device') {
      return setOpenDeviceModal(state);
    }

    if (modal_name === 'change_password_clerk') {
      return setOpenClerkChangePasswordModal(state);
    }

    if (modal_name === 'edit_clerk') {
      return setOpenClerkEditModal(state);
    }
  };

  closeModal = (modal_name) => {
    this.cleanActionStatus();
    this.handleModal(modal_name, false)
  };

  handleClerkModal = (clerk_id, modal_name, status) => {
    this.setState(() => ({selectedUserId: clerk_id}));
    this.handleModal(modal_name, status);
  };

  handleCreateClerk = (clerk) => {
    const {createClerk} = this.props;
    const {firstName: first_name, lastName: last_name, phone: mobile, email, password} = clerk;

    this.cleanActionStatus();

    createClerk({first_name, last_name, mobile: mobile.replace(/[^0-9]/g, ''), email, password});
  };

  handleCreateDevice = (device) => {
    const {createDevice} = this.props;
    const {deviceName: info} = device;

    this.cleanActionStatus();

    createDevice({info});
  };

  handleEditUser = (values, role) => {
    const {editUser} = this.props;

    this.cleanActionStatus();

    return editUser(values);
  }


  handleChangePassword = (values) => {
    const {changePassword} = this.props;
    const {new_password, old_password, user_id} = values;

    this.cleanActionStatus();

    changePassword({new_password, old_password, user_id});
  };

  handlePaginationChange = (e, {activePage}) => {
    const {changeActiveHistoryPage} = this.props;
    changeActiveHistoryPage && changeActiveHistoryPage(activePage)
  };

  showOnlyActiveDevices = (e, {checked}) => {
    const {showOnlyActiveDevices} = this.props;
    showOnlyActiveDevices && showOnlyActiveDevices(checked);
  };

  cleanActionStatus = () => {
    const {dispatchSuccessResponse, dispatchServerError} = this.props;

    dispatchSuccessResponse(false);
    dispatchServerError('');
  };

  renderClerkChangePasswordModal = () => {
    const {serverError, errorMessages, showSuccessResponse, loading, openClerkChangePasswordModal} = this.props;
    const {selectedUserId} = this.state;

    const initialValues = {
      old_password: '',
      new_password: '',
      confirm_new_password: '',
      user_id: selectedUserId
    };

    return (
      <Modal style={{height: "auto"}}
             size="tiny"
             closeOnDimmerClick={false}
             open={openClerkChangePasswordModal}
             onClose={() => this.closeModal('change_password_clerk')}
             closeIcon>
        <Modal.Header>
          {_i18n('change_password')}
        </Modal.Header>
        <Modal.Content>
          <Formik
            initialValues={initialValues}
            validationSchema={changePasswordSchema}
            onSubmit={(values) => this.handleChangePassword(values)}
            render={({values, errors, touched, handleSubmit, handleBlur, handleChange}) => (
              <Form onSubmit={handleSubmit} error={!!serverError} success={showSuccessResponse}>
                <Form.Field required>
                  <label>{_i18n('old_password')}</label>
                  <Input
                    className={'form-field-pb5'}
                    type="password"
                    name="old_password"
                    value={values.old_password}
                    onBlur={handleBlur}
                    onChange={handleChange}/>
                  {errors.old_password && touched.old_password &&
                  <Label className={'label-custom'} basic color='red' pointing>{errors.old_password}</Label>}
                </Form.Field>

                <Form.Field required>
                  <label>{_i18n('new_password')}</label>
                  <Input
                    className={'form-field-pb5'}
                    type="password"
                    name="new_password"
                    value={values.new_password}
                    onBlur={handleBlur}
                    onChange={handleChange}/>

                  {errors.new_password && touched.new_password &&
                  <Label className={'label-custom'} basic color='red' pointing>{errors.new_password}</Label>}
                </Form.Field>

                <Form.Field required>
                  <label>{_i18n('confirm_new_password')}</label>
                  <Input
                    className={'form-field-pb5'}
                    type="password"
                    name="confirm_new_password"
                    value={values.confirm_new_password}
                    onBlur={handleBlur}
                    onChange={handleChange}/>

                  {errors.confirm_new_password && touched.confirm_new_password &&
                  <Label className={'label-custom'} basic color='red' pointing>{errors.confirm_new_password}</Label>}
                </Form.Field>

                <Message error>
                  <Message.List items={errorMessages} />
                </Message>

                <Message
                  success
                  content={_i18n('password_changed')}
                />

                <Button type="submit"
                        style={{float: 'right', margin: '10px 0'}}
                        positive
                        disabled={loading}
                        loading={loading}
                        icon='checkmark'
                        labelPosition='right'
                        content={_i18n('submit')}/>

              </Form>
            )}/>
        </Modal.Content>
      </Modal>
    )
  };

  renderEditClerkModal = () => {
    const {serverError, errorMessages, showSuccessResponse, loading, openClerkEditModal, employees} = this.props;
    const {selectedUserId} = this.state;

    const user = _.find(employees, (c) => c.id === selectedUserId);
    if (!user) return;

    const initialValues = {
      first_name: user.first_name,
      last_name: user.last_name,
      email: user.email,
      user_id: user.id
    };

    return (
      <Modal style={{height: "auto"}}
             size="tiny"
             closeOnDimmerClick={false}
             open={openClerkEditModal}
             onClose={() => this.closeModal('edit_clerk')}
             closeIcon>

        <Modal.Header>
          {_i18n('edit_employee')}
        </Modal.Header>

        <Modal.Content>
          <Formik
            initialValues={initialValues}
            validationSchema={editClerkSchema}
            onSubmit={(values) => this.handleEditUser(values, user.role)}
            render={({values, errors, touched, handleSubmit, handleBlur, handleChange}) => (
              <Form onSubmit={handleSubmit} error={!!serverError} success={showSuccessResponse}>

                <Form.Field required>
                  <label>
                    {_i18n('first_name')}
                  </label>
                  <Input
                    name="first_name"
                    placeholder={_i18n('first_name')}
                    value={values.first_name}
                    onBlur={handleBlur}
                    onChange={handleChange}/>

                  {errors.first_name && touched.first_name ? (
                    <Label basic color='red' pointing>{errors.first_name}</Label>
                  ) : null}
                </Form.Field>

                <Form.Field required>
                  <label>
                    {_i18n('last_name')}
                  </label>
                  <Input name="last_name"
                         placeholder={_i18n('last_name')}
                         value={values.last_name}
                         onBlur={handleBlur}
                         onChange={handleChange}/>

                  {errors.last_name && touched.last_name ? (
                    <Label basic color='red' pointing>{errors.last_name}</Label>
                  ) : null}
                </Form.Field>

                <Form.Field required>
                  <label>
                    {_i18n('email')}
                  </label>
                  <Input name="email"
                         type="email"
                         placeholder={_i18n('email')}
                         value={values.email}
                         onBlur={handleBlur}
                         onChange={handleChange}/>

                  {errors.email && touched.email ? (
                    <Label basic color='red' pointing>{errors.email}</Label>
                  ) : null}
                </Form.Field>

                <Message error>
                  <Message.List items={errorMessages} />
                </Message>

                <Message
                  success
                  content={_i18n('user_edit_success')}
                />

                <Button type="submit"
                        style={{float: 'right', margin: '10px 0'}}
                        positive
                        disabled={loading}
                        loading={loading}
                        icon='checkmark'
                        labelPosition='right'
                        content={_i18n('submit')}/>

              </Form>
            )}/>

        </Modal.Content>
      </Modal>
    )

  };

  renderCreateClerkModal = () => {
    const {serverError, errorMessages, loading, openClerkModal} = this.props;

    const initialValues = {
      firstName: '',
      lastName: '',
      email: '',
      phone: '',
      password: '',
      confirmPassword: ''
    };

    return (
      <Modal style={{height: "auto"}}
             size="tiny"
             closeOnDimmerClick={false}
             open={openClerkModal}
             onClose={() => this.closeModal('create_clerk')}
             closeIcon>
        <Modal.Header>
          {_i18n('create_clerk')}
        </Modal.Header>
        <Modal.Content>
          <Formik
            initialValues={initialValues}
            validationSchema={newClerkSchema}
            onSubmit={(values) => this.handleCreateClerk(values)}
            render={(props) => (
              <Form onSubmit={props.handleSubmit} error={!!serverError}>

                <Form.Field required>
                  <label>
                    {_i18n('first_name')}
                  </label>
                  <Input
                    name="firstName"
                    placeholder={_i18n('first_name')}
                    value={props.values.firstName}
                    onBlur={props.handleBlur}
                    onChange={props.handleChange}/>

                  {props.errors.firstName && props.touched.firstName ? (
                    <Label basic color='red' pointing>{props.errors.firstName}</Label>
                  ) : null}
                </Form.Field>
                <Form.Field required>
                  <label>
                    {_i18n('last_name')}
                  </label>
                  <Input name="lastName"
                         placeholder={_i18n('last_name')}
                         value={props.values.lastName}
                         onBlur={props.handleBlur}
                         onChange={props.handleChange}/>

                  {props.errors.lastName && props.touched.lastName ? (
                    <Label basic color='red' pointing>{props.errors.lastName}</Label>
                  ) : null}
                </Form.Field>
                <Form.Field required>
                  <label>
                    {_i18n('email')}
                  </label>
                  <Input name="email"
                         type="email"
                         placeholder={_i18n('email')}
                         value={props.values.email}
                         onBlur={props.handleBlur}
                         onChange={props.handleChange}/>

                  {props.errors.email && props.touched.email ? (
                    <Label basic color='red' pointing>{props.errors.email}</Label>
                  ) : null}
                </Form.Field>
                <Form.Field required>
                  <label>
                    {_i18n('phone')}
                  </label>
                  <Input iconPosition='left'>
                    <Icon name='phone'/>
                    <InputMask name="phone"
                               value={props.values.phone}
                               onBlur={props.handleBlur}
                               onChange={props.handleChange}
                               placeholder={_i18n('phone')}
                               mask="+1\ (999) 999-9999"
                               maskChar="_"/>

                  </Input>

                  {props.errors.phone && props.touched.phone ? (
                    <Label basic color='red' pointing>{props.errors.phone}</Label>
                  ) : null}
                </Form.Field>
                <Form.Field required>
                  <label>
                    {_i18n('password')}
                  </label>
                  <Input name="password"
                         type="password"
                         placeholder={_i18n('password')}
                         value={props.values.password}
                         onBlur={props.handleBlur}
                         onChange={props.handleChange}/>

                  {props.errors.password && props.touched.password ? (
                    <Label basic color='red' pointing>{props.errors.password}</Label>
                  ) : null}
                </Form.Field>
                <Form.Field required>
                  <label>{_i18n('confirm_password')}</label>
                  <Input name="confirmPassword"
                         type="password"
                         placeholder={_i18n('confirm_password')}
                         value={props.values.confirmPassword}
                         onBlur={props.handleBlur}
                         onChange={props.handleChange}/>

                  {props.errors.confirmPassword && props.touched.confirmPassword ? (
                    <Label basic color='red' pointing>{props.errors.confirmPassword}</Label>
                  ) : null}
                </Form.Field>

                <Message error>
                  <Message.List items={errorMessages} />
                </Message>

                <Button type="submit"
                        style={{float: 'right', margin: '10px 0'}}
                        positive
                        disabled={loading}
                        loading={loading}
                        icon='checkmark'
                        labelPosition='right'
                        content={_i18n('create')}/>
              </Form>)}/>
        </Modal.Content>
      </Modal>)
  };

  renderCreateDeviceModal = () => {
    const {openDeviceModal} = this.props;

    const initialValues = {
      deviceName: '',
    };

    return (
      <Modal style={{height: "auto"}}
             size="tiny"
             closeOnDimmerClick={false}
             open={openDeviceModal}
             onClose={() => this.closeModal('create_device')}
             closeIcon>
        <Modal.Header>
          {_i18n('create_device')}
        </Modal.Header>
        <Modal.Content>
          <Formik
            initialValues={initialValues}
            validationSchema={deviceSchema}
            onSubmit={(values) => this.handleCreateDevice(values)}
            render={(props) =>
              this.deviceForm(props)
            }/>
        </Modal.Content>
      </Modal>)
  };

  renderEditDeviceModal = () => {
    const {openEditDeviceModal, setOpenEditDeviceModal, deviceChanged} = this.props;
    const {deviceId, deviceName} = deviceChanged;

    const initialValues = {
      deviceName
    };

    return (
      <Modal style={{height: "auto"}}
             size="tiny"
             closeOnDimmerClick={false}
             open={openEditDeviceModal}
             onClose={() => setOpenEditDeviceModal(false)}
             closeIcon>
        <Modal.Header>
          {_i18n('device_update')}
        </Modal.Header>
        <Modal.Content>
          <Formik
            initialValues={initialValues}
            validationSchema={deviceSchema}
            onSubmit={(values) => this.updateDevice(deviceId, 'info', values.deviceName)}
            render={(props) =>
              this.deviceForm(props)
            }/>
        </Modal.Content>
      </Modal>)
  };

  deviceForm = (props) => {
    const {serverError, loading} = this.props;

    return (
      <Form onSubmit={props.handleSubmit} error={!!serverError}>
        <Message
          error
          header={_i18n('server_validation_error')}
          content={serverError}
        />
        <Form.Field required>
          <label>
            {_i18n('device_name')}
          </label>
          <Input
            name="deviceName"
            placeholder={_i18n('device_name')}
            value={props.values.deviceName}
            onBlur={props.handleBlur}
            onChange={props.handleChange}/>

          {props.errors.deviceName && props.touched.deviceName ? (
            <Label basic color='red' pointing>{props.errors.deviceName}</Label>
          ) : null}
        </Form.Field>
        <Button type="submit"
                style={{float: 'right', margin: '10px 0'}}
                positive
                disabled={loading}
                loading={loading}
                icon='checkmark'
                labelPosition='right'
                content={_i18n('save')}/>
      </Form>)
  };

  renderDevicesTab() {
    const {totalPages, activePage} = this.props;

    return (
      <React.Fragment>
        <Grid className={'table-title-container'}>
          <Grid.Row columns={2}>
            <Grid.Column floated='left'>
              <Button basic onClick={() => this.handleModal('create_device', true)}>{_i18n('create_device')}</Button>
            </Grid.Column>
            <Grid.Column floated='right'>
              <Checkbox style={{float: 'right'}} label={_i18n('only_active_devices')}
                        onChange={this.showOnlyActiveDevices}/>
            </Grid.Column>
          </Grid.Row>
        </Grid>

        <Table singleLine>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>{_i18n('device')}</Table.HeaderCell>
              <Table.HeaderCell>{_i18n('attached_user')}</Table.HeaderCell>
              <Table.HeaderCell textAlign="center">{_i18n('enabled')}</Table.HeaderCell>
            </Table.Row>
          </Table.Header>

          <Table.Body>
            {this.renderDevices()}
          </Table.Body>
        </Table>

        <Pagination
          activePage={activePage}
          onPageChange={this.handlePaginationChange}
          firstItem={null}
          lastItem={null}
          pointing
          secondary
          className='center-pagination'
          totalPages={totalPages}
        />

      </React.Fragment>
    )
  }

  renderEmployeesTab() {

    return (
      <React.Fragment>

        <Grid className={'table-title-container'}>
          <Grid.Row columns={1}>
            <Grid.Column>
              <Button basic onClick={() => this.handleModal('create_clerk', true)}>{_i18n('create_clerk')}</Button>
            </Grid.Column>
          </Grid.Row>
        </Grid>

        <Table singleLine>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>{_i18n('employee_name')}</Table.HeaderCell>
              <Table.HeaderCell>{_i18n('phone')}</Table.HeaderCell>
              <Table.HeaderCell>{_i18n('email')}</Table.HeaderCell>
              <Table.HeaderCell textAlign="center">{_i18n('edit')}</Table.HeaderCell>
              <Table.HeaderCell textAlign="center">{_i18n('change_password')}</Table.HeaderCell>
            </Table.Row>
          </Table.Header>

          <Table.Body>
            {this.renderEmployees()}
          </Table.Body>
        </Table>

      </React.Fragment>
    )
  }

  render() {

    return (
      <React.Fragment>

        <Tab menu={{secondary: true}} panes={
          [
            {
              menuItem: {key: 'devices', icon: 'computer', content: _i18n('devices')},
              render: () => <Tab.Pane className={'tab-custom'} attached={false}>{this.renderDevicesTab()}</Tab.Pane>
            },
            {
              menuItem: {key: 'employees', icon: 'users', content: _i18n('employees')},
              render: () => <Tab.Pane className={'tab-custom'} attached={false}>{this.renderEmployeesTab()}</Tab.Pane>
            },
          ]
        }/>

        {this.renderCreateClerkModal()}
        {this.renderCreateDeviceModal()}
        {this.renderEditDeviceModal()}
        {this.renderClerkChangePasswordModal()}
        {this.renderEditClerkModal()}

      </React.Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Clerks/components/ClerksView.js